module.exports = __webpack_public_path__ + "img/c04_unitmagus_Normal_ua.c50a1bf6.webp";